<template>
  <div class="class-event-form w-full">
    <div class="md-layout">
      <!-- CLASS NAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <validation-field name="class name" type="autocomplete">
          <isis-autocomplete
            v-model="className"
            :value.sync="eventCfg.class_id"
            :options.sync="classOpts"
            :refetchOptions="getClassOpts"
            :fields="{ text: 'name', value: 'id' }"
            :fetchOnOpen="true"
            search-key="name__~"
            label="Choose class by entering class name to search"
          />
        </validation-field>
      </div>
      <!-- CLASS NAME -->

      <!-- OPTIONS -->
      <div class="md-layout-item md-size-50 md-small-size-100 flex">
        <div class="flex-1 ml-6">
          <md-switch v-model="eventCfg.is_all_day" class="isis-switch-field">{{
            $t("schedule.all_day")
          }}</md-switch>
        </div>
      </div>
      <!-- OPTIONS -->

      <!-- DATE RANGE -->
      <div class="md-layout-item md-size-33 md-small-size-100">
        <date-picker-custom label="schedule.choose_date" v-model="eventDate">
        </date-picker-custom>
      </div>
      <!-- DATE RANGE -->

      <!-- TIME RANGE -->
      <div
        v-if="!eventCfg.is_all_day"
        class="md-layout-item md-size-66 md-small-size-100"
      >
        <div class="time-range flex w-full">
          <isis-time-picker v-model="eventStartTime" class="flex-w-auto" />

          <span class="linking-word text-center"> to </span>

          <isis-time-picker v-model="eventEndTime" class="flex-w-auto" />
        </div>
      </div>
      <!-- TIME RANGE -->

      <!-- TIME ZONE -->
      <div
        class="md-layout-item md-size-33 md-small-size-100 z-10"
        v-if="!eventCfg.is_all_day"
      >
        <isis-autocomplete
          v-model="tzDisplayValue"
          :value.sync="eventCfg.timezone"
          :options="timeZoneOpts"
          label="Time zone"
        >
        </isis-autocomplete>
      </div>
      <!-- TIME ZONE -->

      <!-- Location -->
      <div class="md-layout-item md-small-size-100 md-size-33">
        <md-field>
          <label>Location</label>
          <md-input v-model="eventCfg.location"></md-input>
        </md-field>
      </div>
      <!-- Location -->

      <!-- Description -->
      <div class="md-layout-item md-small-size-100 md-size-33">
        <md-field>
          <label>Description</label>
          <md-input v-model="eventCfg.description"></md-input>
        </md-field>
      </div>
      <!-- Description -->
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { TIMEZONE_OPTION } from "@/constants/Timezone";
import { ISIS_FORMAT, getTimeString } from "@/helpers/datetime-helper";

const initDefaultEventCfg = savedEventCfg => ({
  class_id: savedEventCfg.class_id,
  is_all_day: savedEventCfg.is_all_day,
  start: "",
  end: "",
  timezone: savedEventCfg.timezone,
  location: savedEventCfg.location,
  description: savedEventCfg.description
});

export default {
  name: "class-single-event-form",
  props: ["isisEvent", "editingType"],
  data() {
    const defaultEventCfg = initDefaultEventCfg(this.isisEvent);
    const eventDate = getTimeString(
      this.isisEvent.start,
      this.isisEvent.timezone,
      ISIS_FORMAT.date
    );
    const eventStartTime = getTimeString(
      this.isisEvent.start,
      this.isisEvent.timezone,
      ISIS_FORMAT.time
    );
    const eventEndTime = getTimeString(
      this.isisEvent.end,
      this.isisEvent.timezone,
      ISIS_FORMAT.time
    );

    const className = this.isisEvent?.class?.name ?? "";

    return {
      className,
      classOpts: [],
      timeZoneOpts: TIMEZONE_OPTION,
      eventCfg: defaultEventCfg,
      tzDisplayValue: defaultEventCfg.timezone,
      eventStartTime,
      eventEndTime,
      eventDate
    };
  },
  computed: {
    isEditingMode() {
      return !!this.isisEvent;
    }
  },
  created() {
    this.getClassOpts({
      "name__~": this.className
    });
  },
  methods: {
    getClassOpts(queryObj) {
      return this.$axios
        .get(
          service_paths.classes,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data: resData }) => {
          this.classOpts = resData?.data;
        });
    },

    getEventCfg() {
      const start = this.eventCfg.is_all_day
        ? this.eventDate
        : `${this.eventDate} ${this.eventStartTime}`;
      const end = this.eventCfg.is_all_day
        ? this.eventDate
        : `${this.eventDate} ${this.eventEndTime}`;
      return { ...this.eventCfg, start, end };
    }
  }
};
</script>

<style lang="scss" scoped>
.isis-switch-field {
  margin-top: 30px;
}
</style>
